import { Injectable } from '@angular/core';
import { PaginatedState, PaginatedStateModel } from '@shared/ui';

export interface ResourceData {
  id: string;
  name: string;
  type: string;
  description?: string;
  nestedResourcesCount: number;

  /*
   * True for resources that exist only client-side and have not yet been persisted.
   */
  pending?: boolean;
}

export interface ResourceStateModel extends PaginatedStateModel<ResourceData> {
  /**
   * Restrict the listed catalog to a single resource type. Undefined = no
   * restriction. A fixed per-scope value (e.g. the mask manager lists only
   * responses), set once before the first load — not a runtime toggle.
   */
  typeFilter?: string;
}

@Injectable()
export class ResourceState extends PaginatedState<ResourceData, ResourceStateModel> {
  constructor() {
    super({}, { typeFilter: undefined });
  }

  // Backwards-compat aliases
  public readonly resources$ = this.items$;
  public readonly nextResourceToken$ = this.nextToken$;
  public readonly previousResourceTokens$ = this.previousTokens$;
  public readonly resourcesLoaded$ = this.itemsLoaded$;
  public readonly noResources$ = this.noItems$;

  // ============================================================================
  // Type filter (mirror of PipelineState.environmentFilter)
  // ============================================================================

  public readonly typeFilter$ = this.select((state) => state.typeFilter);

  public readonly setTypeFilter = this.updater((state, typeFilter: string | undefined) => ({
    ...state,
    typeFilter,
  }));
}
